import {Analytics} from "../analytics";
import Moment from "react-moment";
import React from 'react'
import TripApiService from "../services/tripApiService";
import { withCookies } from 'react-cookie';
import TokenManager from "../utils/tokenManager";

class Toolbar extends React.Component {
    constructor(props) {
        super(props);

        const { cookies, tripApiService } = props
        this.tripApiService = tripApiService

        this.state = {
            error: null,
            is_loading: false,
            battery_status: {
                battery_level: null,
                last_updated_at: null
            },
            trip: {
                id: null,
                state: null,
                state_last_changed: null,
                last_location_date: null
            },
            modal: {
                is_open: false
            }
        };


    }

    closeModal = () => {
        Analytics.track('Click: Close Alarm Modal', {tripId: this.state.trip.id});
        this.setState({
            modal: {
                is_open: false
            }
        })
    };

    promptAlarm = () => {
        Analytics.track("Click: Prompt Activate Alarm", {tripId: this.state.trip.id});

        this.setState({
            modal: {
                is_open: true
            }
        })
    }

     async activateAlarm () {
        const trip_id = this.props.trip.id

        Analytics.track('Confirm: Activate Alarm', {tripId: trip_id});
        this.setState({
            is_loading: true,
            modal: {
                is_open: false
            }
        });


        try {
            const resp = await this.tripApiService.activateAlarm(trip_id)
            this.setState({
                is_loading: false
            });
            if (resp.status >= 200 && resp.status < 300) {
                this.setState({
                    trip: {
                        state: 'emergency'
                    },
                    error: null
                });
            } else {
                this.setState({
                    error: 'Error'
                });
            }
        } catch (e) {
                this.setState({
                    error: 'failed',
                    is_loading: false
                });
        }

    };

    render() {
        return (
            <div>
                <div className='w260 round shadow-darken10 px12 py12 txt-s fixed-menu'>


                    {this.props.trip.state ? (
                        <div>

                            {this.props.trip.state &&
                            <p className='block mb6'><b>Status:</b> {this.props.trip.state} (<Moment fromNow>{this.props.trip.state_last_changed}</Moment>) </p>
                            }


                            {(this.props.battery_status && this.props.battery_status.battery_level && this.props.trip.state !== 'complete') &&
                            <p className='block mb6'><b>Battery:</b> {this.props.battery_status.battery_level}%</p>
                            }

                            {(this.props.trip.last_location_date && this.props.trip.state !== 'complete') &&
                            <p className='block mb6'>Last update received <Moment fromNow>{this.props.trip.last_location_date}</Moment></p>
                            }


                            {this.state.error &&
                            <p className='block mb6 color-red'><b>{this.state.error}</b></p>
                            }




                            {(this.props.trip.state !== 'complete' && this.props.trip.state !== 'emergency' && this.state.trip.state !== 'emergency') &&
                            <div>
                                {this.state.is_loading  ? (
                                    <div className='loading'></div>
                                ) : (
                                    <div className='grid mb6 mt12'>
                                        <button className='btn btn--red' onClick={this.promptAlarm}>Activate Noonlight</button>
                                    </div>
                                )}

                            </div>
                            }



                            {(this.props.trip.state === 'emergency' || this.state.trip.state === 'emergency') && this.props.trip.state !== 'complete' &&
                            <p className='block mb6 color-red'><b>Help is on the way.</b></p>
                            }

                            {this.props.trip.state === 'complete' &&
                            <p className='block mb6 color-blue'><b>The trip has been safely ended.</b></p>
                            }
                        </div>
                    ):(
                        <div>
                            <div className='loading'></div>
                        </div>
                    )}


                </div>
                <div>
                    {this.state.modal.is_open &&
                    <div className='bg-darken10 viewport-half mx24'>
                        <div className='flex-parent flex-parent--center-main pt36'>
                            <div className='flex-child bg-white round relative w600'>

                                <div className='px24 py24 align-center'>
                                    <div className='txt-l mb12 txt-bold'>Are you sure?</div>
                                    <div className='txt-m'>
                                        Do you want to send police to this person?
                                    </div>
                                </div>
                                <div className='align-center mx18'>
                                    <button className='btn btn--red wmin-full mb18' onClick={() => this.activateAlarm()}>Yes, Send Police</button>
                                    <button className='btn btn--stroke wmin-full mb30' onClick={this.closeModal}>Cancel</button>

                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        );
    }
}

export default withCookies(Toolbar)



// WEBPACK FOOTER //
// ./src/components/toolbar.js